import { AuthorizationConfig } from '@grotem/grotem.box.angular.auth-lib';

import { AUTH_CLIENT_ID, AUTH_DUMMY_CLIENT_SECRET, AUTH_RESPONSE_TYPE, AUTH_SCOPE } from '@shared/consts/auth-info';
import { environment } from '../../environments/environment';

export const AUTH_CONFIG: AuthorizationConfig = {
  // Identity requests must not refresh themselves after a 401.
  interceptorConfig: {
    paths: { exclude: [environment.auth.issuerUrl] },
  },
  customAuthConfig: {
    clearHashAfterLogin: true,
    useSilentRefresh: false,
    nonceStateSeparator: 'semicolon',

    loginUrl: `${environment.auth.issuerUrl}/login`,
    issuer: environment.auth.issuerUrl,
    clientId: AUTH_CLIENT_ID,
    dummyClientSecret: AUTH_DUMMY_CLIENT_SECRET,
    requireHttps: false,

    redirectUri: environment.auth.frontUrl,
    logoutUrl: `${environment.auth.issuerUrl}/logout`,
    responseType: AUTH_RESPONSE_TYPE,
    postLogoutRedirectUri: environment.auth.frontUrl,
    scope: AUTH_SCOPE,
    // OAuth debug output includes token responses, even in a local build.
    showDebugInformation: false,

    disableAtHashCheck: false,
    strictDiscoveryDocumentValidation: false,
  },
  customAuthModuleConfig: {
    resourceServer: {
      allowedUrls: ['/bff-b2bweb', `${environment.backendUrl.replace(/\/$/, '')}/bff-b2bweb`],
      sendAccessToken: true,
    },
  },
};
